// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this,
            args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

Promise.__proto__.delayed = ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
};

Promise.__proto__.waitUntil = async (cb, delay = 10) => {
    while (true) {
        if (cb()) return;
        await Promise.delayed(delay);
    }
};



// WEBPACK FOOTER //
// ./src/plano/utils/timer.js